import { Base } from '../core/base.model';
import { Usuario } from './usuario.model';
export class Persona extends Base{

  public id: number;
  public nombre: string;
  public apellidoPaterno: string;
  public apellidoMaterno: string;
  public correoelectronico: string;
  public usuarios:Usuario = new  Usuario ();
  public codigo: string;
  public logoBase64: string;
  public telefono: string;
  public nombreCompleto: string;
  public fechaNacimiento: string;
 


}
export class ConsultaPerfil {
  sitio: string;
  nombre: String;
  id: Number;
  menus: ConsultaMenus [];
}
export class ConsultaMenus {
  id: Number;
  id_Padre: Number;
  factory: String;
  nombre: String;
  Sitio: String;
  imagen: String;
  icono: Number;
  tipo: String;
  collapse: String;
}

export class Corporativobean {
  id: Number;
  nombre: String;
  telefono: String;
  correoelectronico: String; 
  repre_legal: String;
}